import type { FaireProductEntity } from "../../entity_types/product";

export const p_5wxg72vddw: FaireProductEntity = {
  token: "p_5wxg72vddw",
  type: "product",
  name: "Abalone Shell Cone Tree with Pearl Topper (Natural)",
  brandName: "Dekorasyon Gifts  Decor",
  imageUrl:
    "https://cdn.faire.com/fastly/354480e4b61a55268c6e45f233802c0ceaf81f66839cbd4999b4fa9951ec3752.jpeg",
  priceDollars: 32,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/9466f061488942811731da243ab5275c8f0d28a406fe402c3586abe0960741b6.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
